import { render } from "./sharelist.vue?vue&type=template&id=4b8e1e98"
import script from "./sharelist.vue?vue&type=script&lang=js"
export * from "./sharelist.vue?vue&type=script&lang=js"

import exportComponent from "F:\\chatpc\\chatadmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__